// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NBxE","col":"styles_col__1sOY3"};